'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = expireRange;

var _applyRange2 = require('./_apply-range');

var _applyRange3 = _interopRequireDefault(_applyRange2);

var _applyEmptyState2 = require('./_apply-empty-state');

var _applyEmptyState3 = _interopRequireDefault(_applyEmptyState2);

var _expire2 = require('./_expire');

var _expire3 = _interopRequireDefault(_expire2);

var _constants = require('../constants');

var _expires2 = require('../status/_expires');

var _expires3 = _interopRequireDefault(_expires2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function expireRange(root, listName, start, end) {
    var opts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    var expires = (0, _expires3.default)((0, _extends3.default)({}, opts, { ttl: -1 }));
    var update = function update(entry) {
        return (0, _expire3.default)(entry, expires);
    };

    root = (0, _applyRange3.default)(root, listName, start, end, update);
    root = (0, _applyEmptyState3.default)(root, listName, {
        expires: expires,
        state: _constants.EXPIRED
    });

    return root;
}